import { render, staticRenderFns } from "./GiftCard.vue?vue&type=template&id=44994a6a&"
import script from "./GiftCard.vue?vue&type=script&lang=js&"
export * from "./GiftCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports